export const reasonGivenData = {
  cancelledTitle: 'What reason were you given for the cancellation?',
  delayedTitle: 'What reason were you given for the delay?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/300941a29f55-tooliconphonemessage.jpg',
  },
  note: [
    'What you write here will appear in the final letter of claim, so please be as clear as possible, including dates.',
  ],
  placeholderText: 'Eg. The airline told me that...',
}
